/**
 * 工具按钮对象
 * <p>
 *   用于本机设备音视频控制的工具按钮的绑定对象。
 * </p>
 */
export default class ToolButton {
  //  按钮的索引
  key: number
  //  按钮的名称
  name: string
  //  按钮活跃状态展示的文案，可以为空。为空时默认展示按钮的名称
  activeTitle?: string
  // 按钮非活跃状态展示的文案，可为空。为空时，按钮在非活跃状态也展示活跃状态下的文案，如果活跃状态文案也不存在，默认展示按钮名称
  inactiveTitle?: string
  // 按钮为非活跃状态时展示的图标
  inactiveImage?: string
  //按钮为活跃状态时展示的图标
  activeImage?: string
  //  按钮的活跃状态，私有属性。
  private active: boolean

  /**
   * 工具按钮构造函数
   * @param key 按钮的索引
   * @param name 按钮的名称
   * @param activeImage 活跃状态展示的图标
   * @param inactiveImage 非活跃状态时展示的图标
   * @param activeTitle 活跃状态展示的文案
   * @param inactiveTitle 非活跃状态展示的文案
   * @param active 活跃状态
   */
  constructor(key: number, name: string, activeImage?: string, inactiveImage?: string,
              activeTitle?: string, inactiveTitle?: string, active?: boolean) {
    this.key = key
    this.name = name
    this.inactiveImage = inactiveImage
    this.activeImage = activeImage
    this.activeTitle = activeTitle
    this.inactiveTitle = inactiveTitle
    if (active !== undefined) {
      this.setActive(active)
    } else {
      this.setActive(true)
    }
  }

  /**
   * 获取当前应该展示的图标
   */
  get img(): string {
    return this.active ? this.activeImage : this.inactiveImage;
  }

  /**
   * 获取当前应该展示的文案
   */
  get showTitle(): string {
    if (this.active) {
      return this.activeTitle ? this.activeTitle : this.name
    } else {
      return this.inactiveTitle ? this.inactiveTitle : this.activeTitle ? this.activeTitle : this.name
    }
  }

  /**
   * 设置按钮的活跃状态
   * @param active
   */
  setActive(active: boolean) {
    this.active = active;
  }

  /**
   * 获取按钮的活跃状态
   */
  getActive(): boolean {
    return this.active;
  }
}
